import React, { useContext } from "react";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config";
import { TruncateWithTooltip } from "@kaltura/mediaspace-shared-ui";
import { translate, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import Links, { LinksProps } from "../links/Links";
import { kafSystemWidth } from "@kaltura/mediaspace-shared-styled";

export interface LeanChannelHeaderProps extends LinksProps {
    name: string;
}

/**
 * Lean channel page header
 * Render only channel name and links
 * Used in KAF media gallery when channelHeaderType is set to no banner
 */
export const StyledLeanHeaderContainer = styled("div")(({ theme }) => ({
    "&": kafSystemWidth({ theme }),
    paddingTop: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        flexDirection: "column",
        alignItems: "start",
        gap: theme.spacing(2),
    },
}));

export function LeanChannelHeader(props: LeanChannelHeaderProps) {
    const { name, ...linksProps } = props;

    const configContext = useContext(ConfigContext);
    const isKaf = configContext.application?.isKAF;

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

    const channelName = !isKaf ? name : translate("Media Gallery");

    return (
        <StyledLeanHeaderContainer className={"kms-ds-channel-page-lean-header"}>
            <TruncateWithTooltip text={channelName} lines={3}>
                <Typography
                    className={"kms-ds-channel-page-lean-header-text"}
                    component={"h1"}
                    variant={isSmallScreen ? "h3" : "h2"}
                >
                    {channelName}
                </Typography>
            </TruncateWithTooltip>
            <Links {...linksProps} />
        </StyledLeanHeaderContainer>
    );
}

export default LeanChannelHeader;
